import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, Loader2Icon } from 'lucide-react';
interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  navItems: Array<{
    id: string;
    label: string;
    icon: React.ElementType;
  }>;
  activeItem: string;
  setActiveItem: (id: string) => void;
  onExport: () => void;
  isExporting: boolean;
}
export const MobileNav: React.FC<MobileNavProps> = ({
  isOpen,
  onClose,
  navItems,
  activeItem,
  setActiveItem,
  onExport,
  isExporting
}) => {
  return <AnimatePresence data-id="element-291" data-mp="1ed5844lq39n3">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="fixed inset-0 bg-black/30 backdrop-blur-sm md:hidden z-40" data-id="element-292" data-mp="zmxwa7q80ovd" />
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} className="fixed bottom-0 inset-x-0 bg-white rounded-t-2xl shadow-2xl md:hidden z-50" data-id="element-293" data-mp="1mmtq4pmx1gdt">
            <div className="relative p-6" data-id="element-294" data-mp="13xeoou3bip8w">
              <div className="absolute left-1/2 -translate-x-1/2 -top-3 w-12 h-1.5 bg-gray-300 rounded-full" data-id="element-295" data-mp="yy24yi7qtyaj" />
              <button onClick={onClose} className="absolute right-5 top-5 p-2 hover:bg-gray-50 rounded-full transition-colors" data-id="element-296" data-mp="1dn6qa89u4imv">
                <XIcon className="h-5 w-5 text-gray-500" data-id="element-297" data-mp="l6duejd57hvo" />
              </button>
              <nav className="mt-8 space-y-2" data-id="element-298" data-mp="l4av18q3ocea">
                {navItems.map(item => {
              const Icon = item.icon;
              return <button key={item.id} onClick={() => {
                setActiveItem(item.id);
                onClose();
              }} className={`flex items-center w-full px-4 py-3.5 rounded-sm text-sm font-medium transition-all ${activeItem === item.id ? 'bg-[#D1005D]/10 text-[#D1005D] shadow-sm' : 'text-[#707070] hover:bg-gray-50'}`} data-id="element-299" data-mp="2g8hbkni2nruy">
                      <Icon className="h-5 w-5 mr-3" data-id="element-300" data-mp="229rdb4jinm50" />
                      {item.label}
                    </button>;
            })}
              </nav>
              <div className="mt-8 space-y-3 px-1" data-id="element-301" data-mp="26a1joib80eke">
                <button disabled={isExporting} onClick={() => {
              onClose();
              onExport();
            }} className="flex items-center justify-center w-full py-3 space-x-2 bg-white border-2 border-[#D1005D] text-[#D1005D] rounded-sm font-medium hover:bg-[#D1005D]/5 transition-colors disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-302" data-mp="2bapi3p1s3xon">
                  {isExporting && <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-303" data-mp="3n3hp673lf3hy" />}
                  <span data-id="element-304" data-mp="3j24ki0c8l6cm">{isExporting ? 'Preparing…' : 'Export report'}</span>
                </button>
                <a href="#" className="flex items-center justify-center w-full py-3 bg-[#D1005D] text-white rounded-sm font-medium hover:bg-[#D1005D]/90 transition-colors" onClick={onClose} data-id="element-305" data-mp="3e31o14abo8g9">
                  Create new test
                </a>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
};